import React from "react";
export const Flag = () => (
  <svg viewBox="0 0 10 16">
    <path d="M6.27 3.67l-.16-.8a.675.675 0 00-.66-.54H.67C.3 2.33 0 2.63 0 3v10a.67.67 0 001.34 0V9h3.73l.16.8c.06.31.33.53.65.53h3.45c.37 0 .67-.3.67-.67V4.33c0-.37-.3-.67-.67-.67H6.27z" />
  </svg>
);
